var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "group-page-chats" },
    [
      _c(
        "group-page-header",
        {
          attrs: {
            title: "Group Chats",
            "left-part-size": 6,
            "right-part-size": 6,
          },
        },
        [
          _c(
            "span",
            { attrs: { slot: "additionalButtons" }, slot: "additionalButtons" },
            [
              _vm.viewerCanCreateConversations
                ? _c("vue-folder-button", {
                    attrs: {
                      text: "Start New",
                      "icon-class": "fa-plus",
                      tabindex: "0",
                      role: "button",
                      "aria-label": "Start New",
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.startConversation.apply(null, arguments)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("vue-folder-button", {
                attrs: {
                  "icon-class": "fa-check",
                  text: "Mark all as read",
                  tabindex: "0",
                  role: "button",
                  "aria-label": "Mark all as read",
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.markAllAsRead.apply(null, arguments)
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-6 group-page-chats__header" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-sm-6 text-right" },
          [
            _c("vue-search-input", {
              on: { search: _vm.onSearch, cancel: _vm.onSearchCancel },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm._l(_vm.results, function (chat) {
        return _c("group-page-chats-chat", {
          key: chat.id,
          attrs: { chat: chat },
          on: {
            leaveChat: function ($event) {
              return _vm.leaveChat(chat)
            },
            followChat: function ($event) {
              return _vm.followChat(chat)
            },
          },
        })
      }),
      _vm._v(" "),
      !_vm.loadingBlock && _vm.results.length === 0
        ? _c("div", { staticClass: "row margin-15-top" }, [
            _c("div", { staticClass: "col-sm-12" }, [
              _c("div", { staticClass: "alert alert-info" }, [
                _vm.query
                  ? _c("span", [
                      _vm._v(
                        "There not any Chats matching your criteria in this Group"
                      ),
                    ])
                  : _c("span", [
                      _vm._v(
                        "There not any Chats have been created in this Group"
                      ),
                    ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "infinite-scroll",
            rawName: "v-infinite-scroll",
            value: _vm.loadMore,
            expression: "loadMore",
          },
        ],
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }